import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-pool-signal',
  templateUrl: './activity-item-pool-signal.component.html',
  styleUrls: ['./activity-item-pool-signal.component.scss']
})
export class ActivityItemPoolSignalComponent implements OnInit {

  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;

  @Input()
  language: 'de' | 'en' = 'de';

  // in a candidate's own feed the candidate goes without saying
  @Input()
  context: string = null;

  texts = texts;

  constructor() { }

  ngOnInit(): void {
  }

}
